import { PayloadAction } from '@reduxjs/toolkit';
import { put, call, takeEvery } from 'typed-redux-saga';
import { toast } from 'react-toastify';

import ApprovalGateway from '~apis/approval';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages, SuccessMessages } from '~utils/constants';
import { TransactionStatusEnum } from '~utils/enums';
import { TDeleteCustomerCollateralReduxParams } from '~types/feat/customer';

export default function* watchDeleteCustomerCollateral(api: ApprovalGateway): SagaWatcherReturnType {
    yield takeEvery('customer/customerDeleteCustomerCollateralAttempt', handleDeleteCustomerCollateral, api);
}

function* handleDeleteCustomerCollateral(api: ApprovalGateway, data: PayloadAction<TDeleteCustomerCollateralReduxParams>) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const {
        customerId,
        collateralId,
    } = data.payload;

    const response = yield* call([api, api.updateCollateralStatus], {
        authToken,
        id: collateralId,
        status: TransactionStatusEnum.Cancelled,
    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.customerDeleteCustomerCollateralFailure(response.message || ErrorMessages.GenericError));
        toast.error(response.message || ErrorMessages.GenericError);
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        const successMessage = SuccessMessages.CustomerCollateralCancelledSuccess;

        yield put(combinedActions.customerSetCustomerCollateralModalIsOpen(false));
        yield put(combinedActions.customerGetCustomerCollateralListingAttempt({ customerId }));
        yield put(combinedActions.customerDeleteCustomerCollateralSuccess());
        yield put(combinedActions.customerGetCustomerDetailsAttempt({ customerId }));
        yield put(combinedActions.customerGetCustomerListingAttempt());

        toast.success(successMessage);
    }
}
